import { Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../auth/service/utils.service";
import { UserService } from "../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { locale as italian } from "../../../../i18n/it";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-user-profile-documents",
  templateUrl: "./user-profile-documents.component.html",
  styleUrls: ["./user-profile-documents.component.scss"],
})
export class UserProfileDocumentsComponent implements OnInit {
  public identifier: any;

  public currentUser: any;

  public contentHeader: IContentHeader;

  public documents_categories: any = ["Contabilità", "Assets", "Contrattuale", "Identità"];

  public documents_statuses: any = [
    {
      value: "rejected",
      label: "Rifiutato",
    },
    {
      value: "pending",
      label: "Da approvare",
    },
    {
      value: "request-sign",
      label: "Da firmare",
    },
    {
      value: "archived",
      label: "Archiviato",
    },
  ];

  public filter_keyword: string = "";

  public filter_category: string = "";

  public filter_status: string = "";

  public tableLimit: number = 10;

  constructor(
    public _utilService: UtilsService,
    private _userService: UserService,
    private router: Router,
    private activated_route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      this.identifier = params.get("user_identifier");
      this.currentUser = await this._userService.get(this.identifier);

      const baseLink: string = "https://cdn.nepta.it/documents/" + this.currentUser.hash;

      this.currentUser.documents = [
        {
          name: "Busta paga Luglio",
          link: baseLink + "/buste-paga/luglio.pdf",
          type: "pdf",
          category: "Contabilità",
          status: "archived",
          status_name: "Archiviato",
          send_date: "2022-08-01",
          open_date: "2022-08-01",
        },
        {
          name: "Busta paga Giugno",
          link: baseLink + "/buste-paga/giugno.pdf",
          type: "xls",
          category: "Contabilità",
          status: "pending",
          status_name: "Da approvare",
          send_date: "2022-07-01",
          open_date: "2022-07-01",
        },
        {
          name: "Busta paga Maggio",
          link: baseLink + "/buste-paga/maggio.pdf",
          type: "doc",
          category: "Contabilità",
          status: "archived",
          status_name: "Archiviato",
          send_date: "2022-06-01",
          open_date: "2022-06-01",
        },
        {
          name: "Ricezione assets aziendale",
          link: baseLink + "/ricezione-computer-aziendale.pdf",
          type: "pdf",
          category: "Assets",
          status: "pending",
          status_name: "Da approvare",
          send_date: "2022-05-15",
          open_date: "2022-05-15",
        },
        {
          name: "Contratto",
          link: baseLink + "/ricezione-computer-aziendale.pdf",
          type: "doc",
          category: "Contrattuale",
          status: "request-sign",
          status_name: "Da firmare",
          send_date: "2022-05-15",
          open_date: "2022-05-15",
        },
        {
          name: "Codice fiscale",
          link: baseLink + "/codice-fiscale.pdf",
          type: "pdf",
          category: "Identità",
          status: "archived",
          status_name: "Archiviato",
          send_date: "2022-05-01",
          open_date: "2022-05-01",
        },
        {
          name: "Carta d'idantità",
          link: baseLink + "/carta-didentita.pdf",
          type: "xls",
          category: "Identità",
          status: "rejected",
          status_name: "Rifiutato",
          send_date: "2022-05-01",
          open_date: "2022-05-01",
        },
        {
          name: "Carta d'idantità",
          link: baseLink + "/carta-didentita.pdf",
          type: "pdf",
          category: "Identità",
          status: "archived",
          status_name: "Archiviato",
          send_date: "2022-05-01",
          open_date: "2022-05-01",
        },
      ];

      this.contentHeader = {
        headerTitle: italian.data.DOCUMENTS,
        actionButton: false,
        breadcrumb: {
          type: "",
          links: [
            {
              name: "Home",
              isLink: true,
              link: "/",
            },
            {
              name: italian.data.TITLES.USERS,
              isLink: false,
            },
            {
              name: italian.data.TITLES.USERS_TYPES[this.currentUser.type_code],
              link: "/dashboard/user/list/" + this.currentUser.type_code,
              isLink: true,
            },
            {
              name: this.currentUser.firstname + " " + this.currentUser.lastname,
              link: "/dashboard/user/profile/" + this.identifier,
              isLink: true,
            },
            {
              name: italian.data.DOCUMENTS,
              isLink: false,
            },
          ],
        },
      };
    });
  }

  getItems() {
    let outputItems: any = this.currentUser.documents;

    if (this.filter_status.length > 0) {
      outputItems = outputItems.filter((item: any) => item.status === this.filter_status);
    }

    if (this.filter_category.length > 0) {
      outputItems = outputItems.filter((item: any) => item.category === this.filter_category);
    }

    if (this.filter_keyword.length > 0) {
      const keyword = this.filter_keyword.toLowerCase().trim();
      outputItems = outputItems.filter(
        (item) =>
          item.type.toLowerCase().includes(keyword) || item.link.toLowerCase().includes(keyword) || item.name.toLowerCase().includes(keyword) || item.send_date.includes(keyword) || item.open_date.includes(keyword),
      );
    }

    return outputItems;
  }
}
